import { useEffect, useRef } from 'react';
import api from '../api/client';

// Uses Web Audio API — no external asset
let audioCtx = null;
const beep = () => {
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    const now = audioCtx.currentTime;
    // Two-tone quick beep
    [880, 1320].forEach((f, i) => {
      const o = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      o.type = 'sine';
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, now + i * 0.18);
      g.gain.exponentialRampToValueAtTime(0.22, now + i * 0.18 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.18 + 0.16);
      o.connect(g).connect(audioCtx.destination);
      o.start(now + i * 0.18);
      o.stop(now + i * 0.18 + 0.18);
    });
  } catch { /* audio disabled */ }
};

const STORAGE_KEY = 'sf_seen_incident_ids';

const useIncidentAlerts = ({ enabled = true, intervalMs = 45000 } = {}) => {
  const lastCheckRef = useRef(0);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const check = async () => {
      if (Date.now() - lastCheckRef.current < intervalMs - 500) return;
      lastCheckRef.current = Date.now();
      try {
        const { data } = await api.get('/incidents', { params: { priority: 'alta', status: 'abierta' } });
        if (cancelled) return;
        const seen = new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
        const fresh = data.filter((i) => !seen.has(i.id));
        if (fresh.length > 0 && seen.size > 0) {
          // Only ring if we had a baseline seen list (skip first mount)
          beep();
          window.dispatchEvent(new CustomEvent('sf:new-incident', { detail: { count: fresh.length, incidents: fresh } }));
        }
        // update storage (keep last 200 ids)
        const allIds = data.map((i) => i.id);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(allIds.slice(0, 200)));
      } catch { /* ignore */ }
    };
    check();
    const t = setInterval(check, intervalMs);
    return () => { cancelled = true; clearInterval(t); };
  }, [enabled, intervalMs]);
};

export default useIncidentAlerts;
